import { render, staticRenderFns } from "./CardRoom4.vue?vue&type=template&id=1ef432d1&scoped=true"
import script from "./CardRoom4.vue?vue&type=script&lang=js"
export * from "./CardRoom4.vue?vue&type=script&lang=js"
import style0 from "./CardRoom4.vue?vue&type=style&index=0&id=1ef432d1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef432d1",
  null
  
)

export default component.exports